import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import MultiPolygon from "ol/geom/MultiPolygon";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import { getTransform, transform } from "ol/proj";
import { FileStateEnum, SeaSurveyListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { seaSurveyToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addMeasurementsToMap(map: Map, meas: SeaSurveyListDto[]): void {
  // Only for mock data
  const toLonLat = getTransform("EPSG:4326", map.getView().getProjection());
  // Find the measurements layer and add the measurements as features
  const source = findSourceByTitle(map, LayerTitle.Measurements);
  const features: Feature<Geometry>[] = [];
  // const measurements: MeasurementMapItem[];
  meas.forEach((m) => {
    // Convert to internal type
    const convertedMeasurement = seaSurveyToMapItem(m);
    // All files should be processed before adding to map
    if (
      !convertedMeasurement.files?.every(
        (f) => f.queuedFile?.stateId === FileStateEnum.Done,
      )
    ) {
      return;
    }
    // Use first file for location marker, or multipolygon centre if it exists
    const firstInfo = convertedMeasurement?.files?.[0]?.information;
    if (!firstInfo) return;
    const { extentCenterXCarto, extentCenterYCarto } = firstInfo;
    const centroid = convertedMeasurement.multiPoly?.centroid;
    const polygons = convertedMeasurement.multiPoly?.polygons;
    convertedMeasurement.hasBoundary = !!centroid && !!polygons;

    const point = centroid
      ? new Point(transform([centroid.x, centroid.y], "EPSG:4326", "EPSG:3857"))
      : new Point(toLonLat([extentCenterXCarto, extentCenterYCarto]));
    const feat = new Feature({
      geometry: point,
      multiPolygon: polygons
        ? new MultiPolygon(
            polygons.map(
              (p) =>
                new Polygon([
                  p.map((c) => transform([c.x, c.y], "EPSG:4326", "EPSG:3857")),
                ]),
            ),
          )
        : undefined,
    });
    feat.setProperties({ ...convertedMeasurement });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedMeasurement.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
